<template lang="pug">
  v-card
    v-card-text
      v-col.py-0
        v-row( align='center')
          strong.mr-3 {{typeof clave == 'number' ? String(clave+1).padStart(2, 0) : clave}}: 
          span( v-if='!editar_texto && !es_imagen') {{ contenedor }} 
          v-img( v-if='es_imagen' width='50' height='50' contain :src='contenedor' )
          v-text-field( v-model='contenedor_de_texto' v-if='editar_texto' @keyup.enter='solicitar( {acción: "solicitar_actualizar_elemento", contenido: contenedor_de_texto, clave}); editar_texto=false') 
          v-btn( @click='solicitar( {acción: "solicitar_actualizar_elemento", contenido: contenedor_de_texto, clave}); editar_texto=false' icon  color='primary' x-small v-if='editar_texto')
            v-icon( x-small ) fa-save
          Seleccionar_imagen_dialog(v-if='editar_texto'  @seleccionar_imagen='val=>contenedor_de_texto=val') 
          v-btn( @click='editar_texto = true; contenedor_de_texto=contenedor' icon color='primary' x-small v-if='!editar_texto')
            v-icon(x-small) fa-pen
          Boton_eliminar( @solicitar='solicitar' :clave='clave' v-if='!editar_texto')
          v-btn( @click='solicitar( {acción: "solicitar_duplicar_elemento", contenido: contenedor})' icon color='primary' x-small v-if='!editar_texto')
            v-icon(x-small) far fa-copy
      
</template>
<script>
export default {
  data: ()=>({
    contenedor_de_texto: '',
    editar_texto: false,
    seguro: false,
  }),
  props: [
    'clave',
    'contenedor'
  ],
  methods:{

    solicitar(objeto){
       this.$emit("solicitar", objeto )
    }
  },
  computed: {
    es_imagen(){
      return this.contenedor.indexOf('firebasestorage')>-1
    }
  },
  components: {
    Boton_eliminar: ()=>import('./boton_eliminar'),
    Seleccionar_imagen_dialog: ()=>import('./seleccionar_imagen_dialog')
  }
}
</script>